import { headers, baseUrl } from '../../common/credentials';

export const port = "1200";

export const port1 = "50003";

export const GetProcessNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/Process/";
    return ([headers, url]);
}

export const Getsourcecolumnnames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getsourcecolumnnames/";
    return ([headers, url]);
}

export const CreateData = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamiccreate/";
    return ([headers, url]);
}

export const Updatevalues = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicupdatedata/";
    return ([headers, url]);
}


export const GetProcessNames1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/savematchingrulesdata/";
    return ([headers, url]);
}

export const GetMatchingRules = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/process_data/matching_rules/";
    return ([headers, url]);
}

export const GetProcessNames2 = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/editsavematchingrulesdata/";
    return ([headers, url]);
}

export const GetMatchingRulesAll = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/process_data/matching_rules/";
    return ([headers, url]);
}


export const GetRelationshipNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/process_data/relationships/";
    return ([headers, url]);
}

export const GetIdentifierNames = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/api/getidentifiertype/";
    return ([headers, url]);
}

export const Getschemaslist = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getschemaslist/";
    return ([headers, url]);
}

export const Gettablelist = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/gettableslist/";
    return ([headers, url]);
}

export const Getcolumnslist = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getcolumnslist/";
    return ([headers, url]);
}


export const GetJobNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/Job/";
    return ([headers, url]);
}

export const GetKpiNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/Kpi/";
    return ([headers, url]);
}

export const GetSourceNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/SourceMaster/";
    return ([headers, url]);
}

export const GetfilterdJobNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamicfilteredlist/Process/";
    return ([headers, url]);
}


export const GetAllPages = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all/Pages/";
    return ([headers, url]);
}

export const GetAllentities = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all/Entities/";
    return ([headers, url]);
}

export const GetAlldivision = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all/Divisions/";
    return ([headers, url]);
}

export const GetroleNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/RoleMaster/";
    return ([headers, url]);
}

export const GetroleName = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getroledata/";
    return ([headers, url]);
}

export const SaveProcess1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamiccreate/Process/";
    return ([headers, url]);
}


export const SavePermissions = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamiccreate/Permission/";
    return ([headers, url]);
}

export const SaveRelationship = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamiccreate/Relationship/";
    return ([headers, url]);
}

export const GetProcessCategoryNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/Process_category/";
    return ([headers, url]);
}

// export const GetCustomerNames = () => {
//     let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/CustomersList/";
//     return ([headers, url]);
// }

export const GetCustomerNames = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_all_data/account_receivable/client_master/";
    return ([headers, url]);
}


export const SaveCustomerMapping = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamiccreate/CustomerMapping/";
    return ([headers, url]);
}

export const Fetchexecutequery = () => {
    let url = baseUrl +  "/api/v2/user_modules/getexecutequery/";
    return ([headers, url]);
}


export const Fetchusersdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_all_data/user_management/users/";
    return ([headers, url]);
}


export const FetchClientids = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/account_receivable/client_master/";
    return ([headers, url]);
}


export const generateschema = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/generate_schemas/";
    return ([headers, url]);
}

export const fetchmailloginfo = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/fetch_mail_info/";
    return ([headers, url]);
}

// export const GetroleNames = () => {
//     let url = baseUrl +  "/api/v2/user_modules/api/get_all_data/RoleMaster/";
//     return ([headers, url]);
// }